export default "__VITE_ASSET__C0Y$r$8N__"